import React from 'react';
import { EProjectStatus } from '@app/swagger-types';
import { AdminProjectsPageBody } from '@app/domain/project/components/AdminProjectsPageBody';
import { useMatchActiveRoute } from '@app/router';
import { Routes } from '@app/constants/routes';

export const AdminScheduledProjectsPage: React.FC = () => {
  const isActive = useMatchActiveRoute([Routes.projects.scheduledProjects]);

  return (
    <div className={isActive ? 'block' : 'hidden'}>
      <AdminProjectsPageBody filterStatus={EProjectStatus.SCHEDULED} />
    </div>
  );
};
